// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1nDKp","location":"Header_location__NoEjz"};